import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import dashboard from './module/dashboard'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    dashboard
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js